<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">The 614th Tank Destroyer Battalion</span></h1>
<p class="titlea"><span class="bold">Fighting on Both Fronts</span></p>
<p class="author"><span class="bold">Samuel de Korte</span></p>
<div class="image_containerc">
<img alt="images" src="images/f0iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?ef753b8c